export default function FieldsRequiredComponent() {
	'ngInject';
	return {
		template: require('./fields-required.html'),
		restrict: 'E',
		transclude: true,
		scope: false
	};
}
